module.exports = __webpack_public_path__ + "831f6b8cf3585a9f3a77da700debb63c.MP3";